import { useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Megaphone, Receipt, ExternalLink } from "lucide-react";
import { PLATFORMS } from "./BrandAdsPanel";

const gbp = (n) => `£${(n || 0).toFixed(2)}`;
const LABEL = { accrued: "Due this month", queried: "Under review", invoiced: "Invoiced to brand", paid: "Paid to wallet", void: "Removed" };

function SpendRow({ e, onDone }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const send = async () => {
    try { await api.post(`/affiliate/events/${e.id}/query`, { reason }); toast.success("Query sent — Nexus will review it before this is paid"); setOpen(false); onDone(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Couldn't send"); }
  };
  return (
    <div className="text-xs border-t border-white/5 pt-2 mt-2" data-testid={`ad-spend-row-${e.id}`}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <span className="text-zinc-400">{e.month} · {gbp(e.amount)} spent × {e.pct}% = <span className="text-emerald-300 font-semibold">{gbp(e.commission)}</span></span>
        <span className="flex items-center gap-2">
          {e.receipt_url && <a href={e.receipt_url} target="_blank" rel="noreferrer" className="flex items-center gap-1 text-zinc-400 hover:text-white" data-testid={`receipt-${e.id}`}><Receipt className="h-3 w-3" /> Receipt</a>}
          <span className={e.status === "queried" ? "text-amber-300" : e.status === "paid" ? "text-emerald-300" : "text-zinc-500"}>{LABEL[e.status] || e.status}</span>
          {e.status === "accrued" && <button onClick={() => setOpen(!open)} className="text-nexus-pink hover:underline" data-testid={`query-btn-${e.id}`}>Query</button>}
        </span>
      </div>
      {e.resolution && <div className="text-zinc-500 mt-1">Reviewed by Nexus: {e.resolution.decision === "adjust" ? `corrected from ${gbp(e.resolution.original_spend)}` : e.resolution.decision}{e.resolution.note ? ` · ${e.resolution.note}` : ""}</div>}
      {open && <div className="mt-2 space-y-2"><Textarea value={reason} onChange={(x) => setReason(x.target.value)} placeholder="What looks wrong? e.g. my ads dashboard shows £400, not £200" className="bg-white/[0.02] border-white/10 text-white text-xs" data-testid={`query-reason-${e.id}`} /><Button size="sm" onClick={send} disabled={reason.trim().length < 5} className="rounded-full nexus-gradient text-white border-0 h-8" data-testid={`query-submit-${e.id}`}>Send to Nexus</Button></div>}
    </div>
  );
}

export function CreatorAdEarnings({ ads, total, onDone }) {
  return (
    <section data-testid="creator-ad-earnings">
      <h2 className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3 flex items-center gap-2"><Megaphone className="h-3.5 w-3.5" /> Brands running your content as ads · {gbp(total)} earned</h2>
      {ads.length === 0 && <div className="glass rounded-2xl p-6 text-sm text-zinc-500" data-testid="ad-earnings-empty">When a brand runs your video or image as a paid ad, it shows here with the spend, the receipt and your share.</div>}
      <div className="grid md:grid-cols-2 gap-3">
        {ads.map((a) => (
          <div key={a.id} className="glass rounded-2xl p-4" data-testid={`creator-ad-${a.id}`}>
            <div className="flex items-center justify-between gap-2"><div className="min-w-0"><div className="font-semibold truncate">{a.ad_name}{a.ad_url && <a href={a.ad_url} target="_blank" rel="noreferrer" className="ml-1 inline-flex text-zinc-500 hover:text-white"><ExternalLink className="h-3 w-3" /></a>}</div><div className="text-xs text-zinc-500">{a.brand_name} · {PLATFORMS[a.platform]} · {a.asset_type}</div></div>
              <div className="text-right shrink-0"><div className="text-emerald-300 font-bold">{gbp(a.commission_total)}</div><div className="text-[10px] text-zinc-500">{gbp(a.spend_total)} spent</div></div></div>
            {(a.events || []).map((e) => <SpendRow key={e.id} e={e} onDone={onDone} />)}
          </div>
        ))}
      </div>
    </section>
  );
}
